<div *ngIf="!postLoad" style="background-color: #e2e2e2">
	<div fxLayout="row" fxLayoutAlign="center center" style="padding: 0.5rem">
		<div class="textWithIcon" fxFlex>
			<mat-icon class="primary-light-color" style="margin-right: 1rem">place</mat-icon>
			<b> Origin</b>
		</div>
		<div fxFlex>
			{{ data.searchTruckForm.origin.city + ', ' + data.searchTruckForm.origin.state }}
		</div>

		<div class="textWithIcon" fxFlex>
			<mat-icon class="primary-light-color" style="margin-right: 1rem">place</mat-icon>
			<b> Destination</b>
		</div>
		<div fxFlex>
			{{ data.searchTruckForm.destination.city + ', ' + data.searchTruckForm.destination.state }}
		</div>

		<div class="textWithIcon" fxFlex>
			<mat-icon class="primary-light-color" style="margin-right: 1rem">local_shipping</mat-icon>
			<b> Trailer Type</b>
		</div>
		<div fxFlex>{{ data.searchTruckForm.trailerType }}</div>
	</div>
</div>

<app-default-progress-bar *ngIf="!isFormInitialized"></app-default-progress-bar>

<div *ngIf="isFormInitialized" style="padding: 1rem">
	<form (keydown.enter)="$event.preventDefault()" [formGroup]="loadDetails">
		<div *ngIf="postLoad">
			<app-search-truck-bar
				(syncFormData)="syncSearchData($event)"
				[allowStateSelection]="false"
				[isEditQuote]="isEditQuote"
				[isFormDataAvailable]="isDuplicateLoad || isEditQuote"
				[load]="load"
				[quote]="quote"
				[showPickupDate]="false"
				[useSearch]="false"
			></app-search-truck-bar>
		</div>

		<div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="2rem">
			<div fxFlex>
				<mat-form-field class="full-width">
					<input
						formControlName="referenceNumber"
						matInput
						placeholder="Reference Number"
						required
					/>
				</mat-form-field>
			</div>

			<div fxFlex>
				<mat-form-field class="full-width">
					<input
						#pdes
						formControlName="productDescription"
						matInput
						placeholder="Product Name / Description"
						required
					/>
				</mat-form-field>
			</div>
		</div>

		<div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="2rem">
			<div fxFlex>
				<mat-form-field class="full-width">
					<input
						formControlName="desiredPrice"
						mask="separator"
						thousandSeparator=","
						prefix="$"
						matInput
						placeholder="{{
							loadDetails.get('trailerType').value === 'TANKER'
								? 'Offered Linehaul Price'
								: 'Offered Buy Now Price'
						}} "
						type="text"
					/>
				</mat-form-field>
			</div>

			<div fxFlex>
				<mat-form-field *ngIf="accountSettingsService.WEIGHT_REQUIRED" class="full-width">
					<input
						formControlName="totalWeight"
						mask="separator"
						thousandSeparator=","
						matInput
						placeholder="Total Weight (lbs)"
						required
						type="text"
					/>
				</mat-form-field>
			</div>
		</div>

		<h4 class="primary-text font-weight-normal" style="margin-top: 0">Pickup</h4>
		<div
			fxLayout="row"
			fxLayoutAlign="center center"
			fxLayoutGap="1rem"
			[ngClass]="{ 'm-b--0-5': pickupDateLeadTimeData.isBeyondLimit }"
		>
			<div fxFlex>
				<mat-form-field fxFlex="100">
					<input
						(click)="picker2.open()"
						(dateChange)="pickupDateChanged($event)"
						[formControl]="pickupDate"
						[matDatepicker]="picker2"
						[min]="minimumPickupDate"
						matInput
						placeholder="Date"
					/>
					<mat-datepicker-toggle [for]="picker2" matSuffix tabIndex="-1"></mat-datepicker-toggle>
					<mat-datepicker #picker2></mat-datepicker>
				</mat-form-field>
			</div>
			<div fxFlex>
				<div class="m-t--1">
					<span class="timepicker-label">Open Time</span>
					<ngx-timepicker-field
						[controlOnly]="true"
						[format]="24"
						defaultTime="08:00"
						formControlName="pickupOpenTime"
						ngDefaultControl
					>
					</ngx-timepicker-field>
				</div>
			</div>

			<div fxFlex>
				<div class="m-t--1">
					<span class="timepicker-label">Close Time</span>
					<ngx-timepicker-field
						[controlOnly]="true"
						[format]="24"
						defaultTime="16:00"
						formControlName="pickupCloseTime"
						ngDefaultControl
					>
					</ngx-timepicker-field>
				</div>
			</div>

			<div fxFlex="22" fxLayoutAlign="end end">
				<mat-checkbox
					color="primary"
					formControlName="pickupAppointment"
					ngDefaultControl
					value="region"
				>
					Appointment Required
				</mat-checkbox>
			</div>
		</div>

		<div
			fxLayout="row"
			*ngIf="pickupDateLeadTimeData.isBeyondLimit"
			class="danger-text font-size-14 m-b-0-5"
		>
			{{ pickupDateLeadTimeData.errorMessage }}
		</div>

		<h4 class="primary-text font-weight-normal" style="margin-top: 0">Delivery</h4>
		<div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="1rem" style="margin-top: 1rem">
			<div fxFlex>
				<mat-form-field fxFlex="100">
					<input
						(click)="picker1.open()"
						[formControl]="estimatedDeliveryDate"
						[matDatepicker]="picker1"
						[min]="minDeliveryDate"
						matInput
						placeholder="Estimated Date"
					/>
					<mat-datepicker-toggle [for]="picker1" matSuffix tabIndex="-1"></mat-datepicker-toggle>
					<mat-datepicker #picker1></mat-datepicker>
				</mat-form-field>
			</div>

			<div fxFlex>
				<div class="m-t--1">
					<span class="timepicker-label">Open Time</span>
					<ngx-timepicker-field
						[controlOnly]="true"
						[format]="24"
						defaultTime="08:00"
						formControlName="deliveryOpenTime"
						ngDefaultControl
					>
					</ngx-timepicker-field>
				</div>
			</div>

			<div fxFlex>
				<div class="m-t--1">
					<span class="timepicker-label">Close Time</span>
					<ngx-timepicker-field
						[controlOnly]="true"
						[format]="24"
						defaultTime="16:00"
						formControlName="deliveryCloseTime"
						ngDefaultControl
					>
					</ngx-timepicker-field>
				</div>
			</div>

			<div fxFlex="22" fxLayoutAlign="end end">
				<mat-checkbox
					color="primary"
					formControlName="deliveryAppointment"
					ngDefaultControl
					value="region"
				>
					Appointment Required
				</mat-checkbox>
			</div>
		</div>

		<div fxLayout="row" fxLayoutGap="2rem">
			<div fxFlex="24" fxLayoutAlign="start center">
				<mat-checkbox color="primary" formControlName="teamService" ngDefaultControl value="region">
					Team Service Required
				</mat-checkbox>
			</div>

			<div
				*ngIf="accountSettingsService.DECLARED_VALUE_REQUIRED"
				fxFlex="24"
				fxLayoutAlign="center center"
			>
				<mat-form-field style="width: 100%">
					<mat-icon class="primary-light-color" matPrefix style="vertical-align: bottom"
						>attach_money
					</mat-icon>
					<input
						formControlName="declaredValue"
						mask="separator"
						thousandSeparator=","
						prefix="$"
						matInput
						placeholder="Declared value"
						required
						type="text"
					/>
				</mat-form-field>
			</div>

			<div fxFlex fxLayoutAlign="end center" *ngIf="showCustomerDropdown">
				<app-customer-popover
					[showCloseIcon]="true"
					[listOnlyWithCustomerCode]="true"
					[showCustomerCode]="true"
					(setCustomer)="setCustomer($event)"
				></app-customer-popover>
			</div>
		</div>

		<div *ngIf="loadDetails.get('trailerType').value === 'FLATBED'" fxLayoutGap="1rem">
			<div fxLayout="row" fxLayoutAlign="center center">
				<div fxFlex>
					<mat-checkbox
						(change)="tarpingModel.tarping = !tarpingModel.tarping"
						[checked]="tarpingModel.tarping"
						color="primary"
						name="tarping"
					>
						Tarping Required
					</mat-checkbox>
				</div>

				<div *ngIf="tarpingModel.tarping" fxFlex>
					<mat-radio-group formControlName="selectedTarping">
						<mat-radio-button
							*ngFor="let tarping of tarpingModel.specifications"
							[value]="tarping.value"
							color="primary"
							style="margin: 0 1rem 0 1rem"
						>
							{{ tarping.label }}
						</mat-radio-button>
					</mat-radio-group>
				</div>
			</div>
		</div>

		<div *ngIf="loadDetails.get('trailerType').value === 'REEFER'">
			<div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="1rem">
				<div fxFlex>
					<div fxLayout="row" fxLayoutAlign="center center">
						<div fxFlex>Temperature</div>
						<div fxFlex>
							<mat-checkbox
								(change)="
									refeerTemperature =
										refeerTemperature == 'range'
											? 'continous'
											: refeerTemperature == ''
											? 'continous'
											: ''
								"
								[checked]="refeerTemperature === 'continous'"
								color="primary"
								name="temperature"
								value="continous"
							>
								Continuous
							</mat-checkbox>
						</div>
						<div fxFlex>
							<mat-checkbox
								(change)="
									refeerTemperature =
										refeerTemperature == 'continous'
											? 'range'
											: refeerTemperature == ''
											? 'range'
											: ''
								"
								[checked]="refeerTemperature === 'range'"
								color="primary"
								name="temperature"
								value="range"
							>
								Range
							</mat-checkbox>
						</div>
					</div>
				</div>

				<div *ngIf="refeerTemperature === 'continous'" fxFlex>
					<mat-slider
						[(ngModel)]="temperatureModel.continuous"
						[displayWith]="formatSliderLabel"
						[ngModelOptions]="{ standalone: true }"
						color="primary"
						max="70"
						min="-35"
						name="continousSlider"
						step="1"
						style="width: 100%"
						thumbLabel
						tickInterval="1"
					>
					</mat-slider>
				</div>

				<div *ngIf="refeerTemperature === 'range'" fxFlex>
					<div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="1rem">
						<div fxFlex>
							<mat-slider
								[(ngModel)]="temperatureModel.range.min"
								[displayWith]="formatSliderLabel"
								[ngModelOptions]="{ standalone: true }"
								color="primary"
								max="70"
								min="-35"
								name="rangeSlider1"
								step="1"
								style="width: 100%"
								thumbLabel
								tickInterval="1"
							>
							</mat-slider>
						</div>
					</div>

					<div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="1rem">
						<div fxFlex>
							<mat-slider
								[(ngModel)]="temperatureModel.range.max"
								[displayWith]="formatSliderLabel"
								[ngModelOptions]="{ standalone: true }"
								color="primary"
								max="70"
								min="-35"
								name="rangeSlider2"
								step="1"
								style="width: 100%"
								thumbLabel
								tickInterval="1"
							>
							</mat-slider>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div *ngIf="loadDetails.get('trailerType').value === 'FLATBED'" class="p-t-1 pb-1">
			<div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="1rem">
				<div fxFlex>
					<div fxLayout="row" fxLayoutAlign="center center">
						<div fxFlex>Trailer Length</div>
						<div fxFlex>
							<mat-radio-group formControlName="trailerLength">
								<mat-radio-button
									*ngFor="let trailerLength of TRAILER_LENGTHS"
									[value]="trailerLength.value"
									[checked]="trailerLength.checked"
									color="primary"
									class="my-0 m-r-1 m-l-1"
								>
									{{ trailerLength.label }}
								</mat-radio-button>
							</mat-radio-group>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="1rem">
			<div fxFlex>
				<mat-form-field style="width: 100%">
					<textarea
						formControlName="specialInstructions"
						matInput
						maxlength="1600"
						placeholder="Special Instructions"
					>
					</textarea>
				</mat-form-field>
			</div>
		</div>

		<div fxLayout="row" fxLayoutGap="1rem">
			<div fxFlex fxLayoutAlign="end end">
				<button
					(click)="onSubmit()"
					*ngIf="!isCreatingLoad && !isEditQuote"
					color="primary"
					mat-raised-button
				>
					<span>{{ !postLoad ? 'Booking Assistant' : 'Post Load' }}</span>
				</button>

				<button
					(click)="updateQuote()"
					*ngIf="!isCreatingLoad && isEditQuote"
					color="primary"
					mat-raised-button
				>
					<span>Update</span>
				</button>

				<mat-spinner *ngIf="isCreatingLoad" [diameter]="30"></mat-spinner>
			</div>
		</div>
	</form>
</div>

<mtx-popover #countPopover="mtxPopover" [closeOnPanelClick]="false">
	<mat-card class="p-0 primary-border">
		<mat-card-content class="count-info-dropdown font-size-14">
			<div class="padding-0-5 primary-text">
				<p>
					The booking assistant works best with carriers you already have a relationship with. To
					leverage your network we only reach out to those carriers.
				</p>
				<p>
					As you talk to carriers about freight be sure to mark them as part of your network or
					Procure them for a project. In the future they will be included in automatic outreach.
				</p>
			</div>
		</mat-card-content>
	</mat-card>
</mtx-popover>
